import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from '@adobe/cq-react-editable-components';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

import { Button } from '@vds/buttons';
import { Grid, Row, Col } from '@vds/grids';
import { Body } from '@vds/typography';
import { ModalBody } from '@vds/modals';

import Header from '../../../common/Heading/head';
import { getAPPID, isDesktopResolution, renderHTML, viewport, crossSiteCheckUrl } from '../../../common/Helpers/index';
import { goToProcessStep } from '../../../../redirection';
import './creditStatus.css';
import Notification from '../../../common/Notification/index';
import { apiUrls } from '../../../../constants/apiUrl';

import { VDSModal as Modal } from '../../../common/Modal/VDSModal';
import getWebAMLoginURL from '../../../../services/UrlMapperService';
import { eventDispatcher } from '../../../common/Tagging';
import logger from '../../../common/ErrorBoundary/logger_new';

export default class CreditStatus extends Container {
  constructor(props) {
    super(props);
    this.type = viewport();
  }

  componentDidMount() {
    if (!this.props.creditStatusLanded) {
      this.props.landedStatusPage();
    }
    this.setState({
      counter: 1,
      maxAtt: true,
    });
  }

  componentDidUpdate() {
    const { validateOrder, securityDepositMessage, securityDeposit, creditDefaultMessage } = this.props;
    const { maxAtt } = this.state;
    if (window.vzdl?.page?.name === 'creditstatus' && !this.state.taggingInfoUpdate) {
      let infoMessage = '';
      if (securityDeposit && securityDeposit > 0) {
        infoMessage = securityDepositMessage;
      } else {
        const headerContent = document.getElementById('creditStatusHeader') ? document.getElementById('creditStatusHeader').innerText : infoMessage;
        infoMessage = maxAtt ? headerContent : 'Your session has timed out, or you have exceeded max number of attempts allowed. ';
        if (validateOrder?.downpaymentRequired && getAPPID() === 'AAL' && this.type === 'desktop') infoMessage = parse(validateOrder.errorMessage);
      }
      if (infoMessage === '') {
        infoMessage = creditDefaultMessage || "Sorry, we couldn't process your request. Please try again or call 866.217.2223 for assistance.";
      }
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar13: infoMessage,
          evar22: 'message displayed',
        },
      });
      this.setState({ taggingInfoUpdate: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const cartInfo = nextProps.creditStatus?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo;
    const { creditApprovalStatus, creditFlow, creditHoldContent } = cartInfo || {};

    let dueToday = nextProps.cartDetails?.orderDetailsView?.dueTodayAmount;
    let securityDeposit = cartInfo?.fwaSecurityDepositAmount;
    let downPaymentAmt = cartInfo?.downPaymentAmount;

    securityDeposit = securityDeposit !== undefined && securityDeposit !== null && securityDeposit !== '' ? securityDeposit : 0;
    downPaymentAmt = downPaymentAmt !== undefined && downPaymentAmt !== null && downPaymentAmt !== '' ? downPaymentAmt : 0;
    dueToday = dueToday !== undefined && dueToday !== null && dueToday !== '' ? dueToday : 0;

    if (this.props.creditReviewSuccessResponseFlag !== nextProps.creditReviewSuccessResponseFlag) {
      if (cartInfo?.eidQuestionnaire?.numOfQuestions > 0) {
        goToProcessStep(this.props.currentView.CreditCheck, nextProps.history);
      } else if (creditApprovalStatus === 'AP') {
        if (creditFlow !== 'EdgeIneligible' && parseFloat(downPaymentAmt) > 0) {
          goToProcessStep(nextProps.currentView.DownPayment, nextProps.history);
        } else if (creditFlow === 'EdgeIneligible') {
          goToProcessStep(nextProps.currentView.EdgeInEligible, nextProps.history);
        } else if (parseFloat(securityDeposit) > 0) {
          goToProcessStep(nextProps.currentView.Payment, nextProps.history);
        } else if (parseFloat(dueToday) > 0) {
          goToProcessStep(nextProps.currentView.Payment, nextProps.history);
          nextProps.updateCreditCheckSuccess();
        } else if (parseFloat(dueToday) === 0 || parseFloat(dueToday) === '0') {
          goToProcessStep(nextProps.currentView.OrderReview, nextProps.history);
        }
      } else if (creditApprovalStatus !== 'AP' && creditHoldContent) {
        goToProcessStep(nextProps.currentView.CreditHold, nextProps.history);
      }
    }
  }

  handelCancelOrder = () => {
    window.location.href = apiUrls().redirect5Ghome;
  };

  handleCreditSubmit = (e) => {
    // if (e) {
    //   e.preventDefault();
    // }

    const { maxAtt } = this.state;
    const nseFlow = getAPPID() !== 'AAL';

    if (maxAtt && nseFlow) {
      this.handleSubmitCredit();
    } else if (maxAtt) {
      this.redirectToHome(e);
    } else {
      this.handelCancelOrder(e);
    }

    // maxAtt
    //   ? nseType
    //     ? () => this.handleSubmitCredit(primaryBtnUrl, creditCheckData)
    //     : (e) => this.redirectToHome(e)
    //   : (e) => this.handelCancelOrder(e)
  };

  handleSubmitCredit() {
    const primaryBtnUrl = this.props.creditHoldContentNse?.PrimaryBtnUrl || '';
    const creditData = this.props.creditCheckDetails?.creditCheckData;

    const { counter } = this.state;
    const creditStatusReasonCode =
      this.props.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.creditStatusReasonCode || '';

    if (counter <= 5 && primaryBtnUrl === '/5g/validateOrder') {
      this.setState({ counter: counter + 1 });
      this.props.reSubmitCreditReview(creditData);
      this.setState({ taggingInfoUpdate: false });
    } else if (counter >= 5) {
      this.setState({ maxAtt: false, taggingInfoUpdate: false });
    } else if (primaryBtnUrl === '/5g/home/' && creditStatusReasonCode === 'RP') {
      // ADDING FOR SIGNIN MODEL AND COMMENTING OUT OLD LOGIC

      // const signInUrl = getWebAMLoginURL();
      // window.location.href = signInUrl;
      const dataPayload = {
        messageType: 'INFO',
        message: 'Clicked on SignIn and SinIn Model opened from creditCheck page',
      };
      logger(dataPayload);
      this.setState({ setsignInModal: true });
      const obj = { name: 'sign in modal opened', selector: '#signinOverlay', data: { page: { throttle: 'nsa version|vhi|sign in' } } };
      eventDispatcher('openView', obj);
    } else if (primaryBtnUrl === '/5g/home/' && creditStatusReasonCode === 'F2') {
      const signInUrl = getWebAMLoginURL();
      window.location.href = signInUrl;
      this.setState({ setsignInModal: true });
      const obj = { name: 'sign in modal opened', selector: '#signinOverlay', data: { page: { throttle: 'nsa version|vhi|sign in' } } };
      eventDispatcher('openView', obj);
    } else if (primaryBtnUrl === '/ui/hub/secure/overview' && (creditStatusReasonCode === 'LM' || creditStatusReasonCode === 'NM')) {
      const signInUrl = 'https://www.verizon.com/digital/nsa/secure/ui/udb/#/';
      window.location.href = signInUrl;
    } else if (getAPPID() === 'AAL') {
      this.redirectToHome();
    } else {
      goToProcessStep(this.props.currentView.Payment, this.props.history);
    }
  }

  getAMURL = () => {
    const hostName = window.location.hostname;
    let APIContext = '';
    if (hostName.indexOf('.verizonwireless.com') > -1) {
      const qaEnv = window.location.host.split('.');
      const lowerEnv = qaEnv && qaEnv[0].substr(qaEnv[0].length - 3);
      const number = lowerEnv?.match(/(\d+)/);
      if (number?.[0] > 9) {
        APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com/vzauth/UI/Login?realm=vzw&goto=https://vzwqa${number[0]}.verizonwireless.com/sales/home/expresscart.html?expresscart=true%26signinfromCredit%3dtrue&userNameOnly=false&rememberUserNameCheckBoxExists=Y&offerShortLivedPassword=Y&mode=o`;
      } else {
        // APIContext = `https://accessmgr${lowerEnv}.verizonwireless.com/vzauth/UI/Login?realm=vzw&goto=https://vzw${lowerEnv}.verizonwireless.com/sales/home/expresscart.html?expresscart=true%26signinfromCredit%3dtrue&userNameOnly=false&rememberUserNameCheckBoxExists=Y&offerShortLivedPassword=Y&mode=o`;
        APIContext = `https://securesit${number?.[0]}.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fvzwqa${number?.[0]}.verizonwireless.com%2Fsales%2Fhome%2Fexpresscart.html%3Fexpresscart%3Dtrue%26signinfromCredit%3dtrue`;
      }
    } else {
      APIContext =
        this.props.plansReferenceData?.signInProdNSAUrl ||
        'https://secure.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https://www.verizon.com/sales/home/expresscart.html?expresscart=true%26signinfromCredit%3dtrue';
    }
    return `${APIContext}`;
  };

  redirectUrl = crossSiteCheckUrl(this.getAMURL());

  toggleShowModal = (value) => {
    this.setState({ setsignInModal: value });
    // setShowSignIn(!value);
  };

  redirectToHome = (e) => {
    if (e) {
      e.preventDefault();
    }
    const { creditHoldContent, validateOrder, currentView, history, resetOrderStatus, getValidateOrder } = this.props;
    if (!creditHoldContent) {
      const orderStatus = validateOrder?.orderDetails?.[0]?.orderStatus || '';
      let updateView = currentView.Success;
      if (validateOrder.downpaymentRequired) {
        updateView = '/';
      } else if (creditHoldContent) {
        updateView = currentView.CreditHold;
      } else if (orderStatus === 'SUCCESS') {
        const selfInstallType = this.props.cartDetails?.orderDetailsView?.installType.toLowerCase().toString().includes('self');
        const dueToday = this.props.cartDetails?.orderDetailsView?.dueTodayAmount;
        if (selfInstallType) {
          updateView = currentView.Success;
        } else if (!selfInstallType) {
          if (dueToday > 0) {
            updateView = currentView.Payment;
          } else {
            updateView = currentView.OrderReview;
          }
        }
      }
      resetOrderStatus();
      goToProcessStep(updateView, history);
    }
    if (creditHoldContent) {
      getValidateOrder();
    }
  };

  renderNotificationMessage = () => {
    const { creditShowError, creditStatusNfyMsg, creditErrorMessage } = this.props;
    if (creditShowError) {
      return (
        <Notification
          hideCloseButton="true"
          type="warning"
          title={creditStatusNfyMsg ? renderHTML(creditStatusNfyMsg) : 'Looks like something went wrong. Please try again later.'}
        />
      );
    }
    if (creditErrorMessage) {
      return <Notification hideCloseButton="true" type="warning" title={creditErrorMessage} />;
    }
  };

  render() {
    const {
      creditHoldContent,
      creditHoldContentNse,
      creditAppNumNse,
      validateOrder,
      securityDepositMessage,
      validatedHoldOrder,
      creditAppNum,
      securityDeposit,
      creditDefaultMessage,
    } = this.props;

    if (validatedHoldOrder) {
      this.redirectToHome();
    }
    let renderContent = '';
    let primaryBtn = 'Continue';
    const { maxAtt } = this.state;

    const maxContent = 'Your session has timed out, or you have exceeded max number of attempts allowed. ';

    if (getAPPID() === 'AAL') {
      if (securityDeposit > 0) {
        renderContent = securityDepositMessage;
      } else if (this.type === 'desktop') {
        if (creditHoldContent) {
          renderContent = parse(creditHoldContent?.Content_D_Screen_1.replace('{{CREDIT_APP_NUM}}', creditAppNum));
        }
        if (validateOrder.downpaymentRequired) {
          renderContent = parse(validateOrder.errorMessage);
        }
      } else if (this.type === 'mobile' || this.type === 'tablet' || this.type === 'mfapp') {
        if (creditHoldContent) {
          renderContent = parse(creditHoldContent?.Content_M_Screen_1.replace('{{CREDIT_APP_NUM}}', creditAppNum));
        }
      }
      primaryBtn = creditHoldContent?.PrimaryBtnLabel || 'Continue';
      // cancelBtn = creditHoldContent?.CancelOrderBtnLabel;
    } else {
      if (securityDeposit > 0) {
        renderContent = securityDepositMessage;
      } else if (this.type === 'desktop') {
        if (creditHoldContentNse) {
          renderContent = parse(creditHoldContentNse?.Content_D_Screen_1.replace('{{CREDIT_APP_NUM}}', creditAppNumNse));
        }
      } else if (this.type === 'mobile' || this.type === 'tablet' || this.type === 'mfapp') {
        if (creditHoldContentNse) {
          renderContent = parse(creditHoldContentNse?.Content_M_Screen_1.replace('{{CREDIT_APP_NUM}}', creditAppNumNse));
        }
      }
      primaryBtn = creditHoldContentNse?.PrimaryBtnLabel || 'Continue';
    }
    const ctaText = maxAtt ? primaryBtn : 'Cancel your order';
    const contentClass = creditHoldContent || creditHoldContentNse ? '' : 'fontSize25 lineHeight25 bold';
    let applyStyle;
    if (this.type !== 'desktop') {
      if (creditHoldContent?.PrimaryBtnLabel || creditHoldContentNse?.PrimaryBtnLabel) {
        applyStyle = { position: 'fixed', paddingTop: '15%' };
      } else if (creditHoldContent?.CancelOrderBtnLabel || creditHoldContentNse?.CancelOrderBtnLabel) {
        applyStyle = { position: 'fixed', paddingTop: '98%' };
      }
    }
    if (renderContent === '') {
      renderContent = creditDefaultMessage || "Sorry, we couldn't process your request. Please try again or call 866.217.2223 for assistance.";
    }
    const creditStatusheading = document.getElementById('creditStatusHeader');
    if (creditStatusheading) {
      const statusHeader = <Header heading={creditStatusheading.innerText} />;
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(statusHeader, creditStatusheading);
    }
    const getCreditStatusCTA = document.getElementById('creditStatusCTA');
    const ctnCTA = (
      <Button role="button" size="large" width="100%" primary onClick={(e) => this.handleCreditSubmit(e)}>
        {ctaText}
      </Button>
    );
    if (getCreditStatusCTA) {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(ctnCTA, document?.getElementById('creditStatusCTA'));
    }
    return (
      <>
        <div>{this.renderNotificationMessage()} </div>
        <Grid className={contentClass} colSizes={{ desktop: 8, mobile: 4, tablet: 11 }}>
          <Row className="noLeftPad noRightPad">
            <Col lg={10} className="noLeftPad noRightPad">
              <div className="CreditStatusWrapper">
                <Body primitive="p" size="large">
                  {maxAtt ? renderContent : maxContent}
                </Body>
              </div>
            </Col>
          </Row>
          <Row>
            {this.state.setsignInModal && (
              <Modal
                id="signinOverlay"
                ariaLabel="sign in modal opened"
                analyticstrack="sign in modal opened"
                opened={this.state.setsignInModal}
                onOpenedChange={this.toggleShowModal}
                disableOutsideClick
              >
                <ModalBody>
                  <iframe id="signinframe" height="600px" width="400px" title={this.redirectUrl} src={this.redirectUrl} />
                </ModalBody>
              </Modal>
            )}
          </Row>
          <Row className="pad20 onlyTopPad btnContinue" style={applyStyle}>
            <Col colSizes={{ desktop: 4, mobile: 4, tablet: 4 }}>
              {!isDesktopResolution() && (
                <Button
                  type="button"
                  analyticstrack="5G-NextSetupStep"
                  width={viewport() === 'mobile' ? '100%' : '150px'}
                  primary
                  onClick={(e) => this.handleCreditSubmit(e)}
                >
                  {ctaText}
                </Button>
              )}
            </Col>
          </Row>
        </Grid>
      </>
    );
  }
}

CreditStatus.propTypes = {
  creditHoldContent: PropTypes.object,
  validateOrder: PropTypes.object,
  currentView: PropTypes.object,
  history: PropTypes.object,
  securityDepositMessage: PropTypes.string,
  getValidateOrder: PropTypes.func,
  validatedHoldOrder: PropTypes.bool,
  resetOrderStatus: PropTypes.func,
  creditAppNum: PropTypes.string,
  creditStatusLanded: PropTypes.bool,
  landedStatusPage: PropTypes.func,
  securityDeposit: PropTypes.any,
};
